export const translations = {
  en: {
    switchToArabic: 'Switch to Arabic',
    beta: 'BETA',
    comingSoon: 'Coming Soon',
    heroTitle1: 'Join the Future of',
    heroTitle2: 'E-Commerce Logistics',
    heroSubtitle:
      'Logix is an all-in-one platform that helps e-commerce businesses manage orders, shipping, inventory, warehouses, drivers, and finances with real-time insights and seamless integrations. Simplify your logistics and scale efficiently.',
    emailPlaceholder: 'Enter your email',
    getEarlyAccess: 'Get Early Access',
    freeOnboarding: 'Free Onboarding',
    noCreditCard: 'No Credit Card Required',
    cancelAnytime: 'Cancel Anytime',
    preview: 'Preview',
    powerfulDashboard: 'Powerful Dashboard for Modern Logistics',
    completeVisibility: 'Get complete visibility into your operations',
    features: 'Features',
    featuresTitle1: 'Powerful',
    featuresTitle2: 'Features',
    featuresSubtitle: 'Everything you need to manage your logistics operations',
    orderManagement: 'Order Management',
    orderManagementDesc: 'Track and manage orders in real-time',
    easyFulfil: 'Easy Fulfillment',
    easyFulfilDesc: 'Streamline your fulfillment process',
    shippingSolutions: 'Shipping Solutions',
    shippingSolutionsDesc: 'Integrate with multiple shipping carriers',
    returnsManagement: 'Returns Management',
    returnsManagementDesc: 'Handle returns efficiently',
    inventoryControl: 'Inventory Control',
    inventoryControlDesc: 'Keep track of your inventory levels',
    manageFleets: 'Fleet Management',
    manageFleetsDesc: 'Manage your delivery fleet',
    benefits: 'Benefits',
    benefitsTitle1: 'Exclusive',
    benefitsTitle2: 'Benefits',
    benefitsSubtitle: 'Join now and get access to exclusive features',
    exclusiveFeatures: 'Exclusive Features',
    exclusiveFeaturesDesc: 'Get access to beta features first',
    earlyAccess: 'Early Access',
    earlyAccessDesc: 'Be among the first to try new features',
    priorityOnboarding: 'Priority Onboarding',
    priorityOnboardingDesc: 'Get personalized onboarding support',
    specialOffers: 'Special Offers',
    specialOffersDesc: 'Exclusive deals for early adopters',
    readyToStart: 'Ready to get started?',
    joinWaitlist: 'Join Waitlist',
    productTour: 'Product Tour',
    responsiveByDesign: 'Responsive by Design',
    optimizedAllScreens: 'Optimized for all screens',
    experienceLogix1: 'Experience',
    experienceLogix2: 'Logix',
    manageLogistics: 'Manage your logistics operations efficiently',
    responsiveInterface: 'Responsive Interface',
    responsiveInterfaceDesc: 'Works seamlessly across all devices',
    advancedAdminTools: 'Advanced Admin Tools',
    advancedAdminToolsDesc: 'Powerful tools for administrators',
    testimonials: 'Testimonials',
    testimonialsTitle1: 'What Our',
    testimonialsTitle2: 'Users Say',
    joinToday1: 'Join',
    joinToday2: 'Today',
    ctaSubtitle: 'Be part of the future of logistics management',
    emailJoinPlaceholder: 'Enter your email to join',
    byJoining: 'By joining, you agree to our',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    faq: 'FAQ',
    faqTitle1: 'Common',
    faqTitle2: 'Questions',
    faqSubtitle: 'Find answers to frequently asked questions',
    stillHaveQuestions: 'Still have questions?',
    contactSupport: 'Contact Support',
    allRightsReserved: '© 2024 Logix. All rights reserved.',
    login: 'Login',
    formStep1: 'Step 1 of 2',
    formStep2: 'Step 2 of 2',
    joinWaitlistTitle: 'Join Our Waitlist',
    completeProfileTitle: 'Complete Your Profile',
    enterEmailText: 'Enter your email to get early access to Logix',
    tellAboutBusinessText: 'Tell us a bit more about your business',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    companyName: 'Company Name',
    monthlyOrders: 'Monthly Orders',
    emailPlaceholder: 'your@email.com',
    phonePlaceholder: 'Your phone number',
    companyPlaceholder: 'Your company name',
    ordersPlaceholder: 'Approximate number of orders',
    continueButton: 'Continue',
    sendButton: 'Send',
    closeButton: 'Close',
    thankYou: 'Thank You!',
    waitlistConfirmation:
      "You've been added to our waitlist. We'll notify you when Logix is ready.",
  },
  ar: {
    switchToArabic: 'Switch to English',
    beta: 'تجريبي',
    comingSoon: 'قريباً',
    heroTitle1: 'انضم إلى مستقبل',
    heroTitle2: 'الخدمات اللوجستية للتجارة الإلكترونية',
    heroSubtitle:
      'لوجيكس هي منصة شاملة تساعد شركات التجارة الإلكترونية على إدارة الطلبات والشحن والمخزون والمستودعات والسائقين والتمويل مع رؤى في الوقت الفعلي وتكاملات سلسة. بسّط الخدمات اللوجستية الخاصة بك وتوسع بكفاءة.',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    getEarlyAccess: 'احصل على وصول مبكر',
    freeOnboarding: 'تدريب مجاني',
    noCreditCard: 'لا تحتاج بطاقة ائتمان',
    cancelAnytime: 'إلغاء في أي وقت',
    preview: 'معاينة',
    powerfulDashboard: 'لوحة تحكم قوية للخدمات اللوجستية الحديثة',
    completeVisibility: 'احصل على رؤية كاملة لعملياتك',
    features: 'المميزات',
    featuresTitle1: 'مميزات',
    featuresTitle2: 'قوية',
    featuresSubtitle: 'كل ما تحتاجه لإدارة عملياتك اللوجستية',
    orderManagement: 'إدارة الطلبات',
    orderManagementDesc: 'تتبع وإدارة الطلبات في الوقت الفعلي',
    easyFulfil: 'تنفيذ سهل',
    easyFulfilDesc: 'تبسيط عملية التنفيذ',
    shippingSolutions: 'حلول الشحن',
    shippingSolutionsDesc: 'التكامل مع شركات الشحن المتعددة',
    returnsManagement: 'إدارة المرتجعات',
    returnsManagementDesc: 'التعامل مع المرتجعات بكفاءة',
    inventoryControl: 'التحكم بالمخزون',
    inventoryControlDesc: 'تتبع مستويات المخزون',
    manageFleets: 'إدارة الأسطول',
    manageFleetsDesc: 'إدارة أسطول التوصيل',
    benefits: 'المزايا',
    benefitsTitle1: 'مزايا',
    benefitsTitle2: 'حصرية',
    benefitsSubtitle: 'انضم الآن واحصل على مزايا حصرية',
    exclusiveFeatures: 'مميزات حصرية',
    exclusiveFeaturesDesc: 'احصل على وصول مبكر للميزات التجريبية',
    earlyAccess: 'وصول مبكر',
    earlyAccessDesc: 'كن من أوائل من يجرب الميزات الجديدة',
    priorityOnboarding: 'تدريب ذو أولوية',
    priorityOnboardingDesc: 'احصل على دعم تدريبي مخصص',
    specialOffers: 'عروض خاصة',
    specialOffersDesc: 'عروض حصرية للمستخدمين الأوائل',
    readyToStart: 'مستعد للبدء؟',
    joinWaitlist: 'انضم لقائمة الانتظار',
    productTour: 'جولة المنتج',
    responsiveByDesign: 'تصميم متجاوب',
    optimizedAllScreens: 'محسن لجميع الشاشات',
    experienceLogix1: 'جرب',
    experienceLogix2: 'لوجيكس',
    manageLogistics: 'أدر عملياتك اللوجستية بكفاءة',
    responsiveInterface: 'واجهة متجاوبة',
    responsiveInterfaceDesc: 'يعمل بسلاسة على جميع الأجهزة',
    advancedAdminTools: 'أدوات إدارة متقدمة',
    advancedAdminToolsDesc: 'أدوات قوية للمسؤولين',
    testimonials: 'آراء العملاء',
    testimonialsTitle1: 'ماذا يقول',
    testimonialsTitle2: 'مستخدمونا',
    joinToday1: 'انضم',
    joinToday2: 'اليوم',
    ctaSubtitle: 'كن جزءاً من مستقبل إدارة الخدمات اللوجستية',
    emailJoinPlaceholder: 'أدخل بريدك الإلكتروني للانضمام',
    byJoining: 'بالانضمام، أنت توافق على',
    termsOfService: 'شروط الخدمة',
    and: 'و',
    privacyPolicy: 'سياسة الخصوصية',
    faq: 'الأسئلة الشائعة',
    faqTitle1: 'الأسئلة',
    faqTitle2: 'الشائعة',
    faqSubtitle: 'اعثر على إجابات للأسئلة المتكررة',
    stillHaveQuestions: 'هل لا تزال لديك أسئلة؟',
    contactSupport: 'اتصل بالدعم',
    allRightsReserved: '© 2024 لوجيكس. جميع الحقوق محفوظة.',
    login: 'تسجيل الدخول',
    formStep1: 'الخطوة 1 من 2',
    formStep2: 'الخطوة 2 من 2',
    joinWaitlistTitle: 'انضم إلى قائمة الانتظار',
    completeProfileTitle: 'أكمل ملفك الشخصي',
    enterEmailText: 'أدخل بريدك الإلكتروني للحصول على وصول مبكر إلى لوجيكس',
    tellAboutBusinessText: 'أخبرنا قليلاً عن عملك',
    emailAddress: 'البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    companyName: 'اسم الشركة',
    monthlyOrders: 'الطلبات الشهرية',
    emailPlaceholder: 'بريدك@مثال.كوم',
    phonePlaceholder: 'رقم هاتفك',
    companyPlaceholder: 'اسم شركتك',
    ordersPlaceholder: 'العدد التقريبي للطلبات',
    continueButton: 'متابعة',
    sendButton: 'إرسال',
    closeButton: 'إغلاق',
    thankYou: 'شكراً لك!',
    waitlistConfirmation:
      'تمت إضافتك إلى قائمة الانتظار. سنعلمك عندما يكون لوجيكس جاهزاً.',
  },
}
export const faqTranslations = {
  en: [
    {
      question: 'What is Logix?',
      answer:
        'Logix is a comprehensive logistics management platform that helps businesses streamline their operations.',
    },
    {
      question: 'How does the waitlist work?',
      answer:
        "Join our waitlist to get early access to the platform. We'll notify you when your access is ready.",
    },
    {
      question: 'Is it free to join?',
      answer:
        'Yes, joining the waitlist is completely free. No credit card required.',
    },
  ],
  ar: [
    {
      question: 'ما هو لوجيكس؟',
      answer:
        'لوجيكس هي منصة شاملة لإدارة الخدمات اللوجستية تساعد الشركات في تبسيط عملياتها.',
    },
    {
      question: 'كيف تعمل قائمة الانتظار؟',
      answer:
        'انضم إلى قائمة الانتظار للحصول على وصول مبكر للمنصة. سنخطرك عندما يكون وصولك جاهزاً.',
    },
    {
      question: 'هل الانضمام مجاني؟',
      answer:
        'نعم، الانضمام إلى قائمة الانتظار مجاني تماماً. لا تحتاج إلى بطاقة ائتمان.',
    },
  ],
}
export const testimonialTranslations = {
  en: [
    {
      name: 'Sarah Johnson',
      role: 'Logistics Manager',
      quote:
        'Logix has transformed how we manage our logistics operations. The interface is intuitive and powerful.',
      image: 'https://i.pravatar.cc/150?img=1',
    },
    {
      name: 'Michael Chen',
      role: 'Operations Director',
      quote:
        'The real-time tracking and analytics have helped us make better decisions and improve efficiency.',
      image: 'https://i.pravatar.cc/150?img=2',
    },
    {
      name: 'Emma Davis',
      role: 'Supply Chain Lead',
      quote:
        'The customer support is exceptional, and the platform keeps getting better with new features.',
      image: 'https://i.pravatar.cc/150?img=3',
    },
  ],
  ar: [
    {
      name: 'سارة جونسون',
      role: 'مدير الخدمات اللوجستية',
      quote:
        'لقد غير لوجيكس طريقة إدارتنا للعمليات اللوجستية. الواجهة بديهية وقوية.',
      image: 'https://i.pravatar.cc/150?img=1',
    },
    {
      name: 'مايكل تشن',
      role: 'مدير العمليات',
      quote:
        'ساعدنا التتبع والتحليلات في الوقت الفعلي على اتخاذ قرارات أفضل وتحسين الكفاءة.',
      image: 'https://i.pravatar.cc/150?img=2',
    },
    {
      name: 'إيما ديفيس',
      role: 'مسؤول سلسلة التوريد',
      quote: 'دعم العملاء استثنائي، والمنصة تتحسن باستمرار مع الميزات الجديدة.',
      image: 'https://i.pravatar.cc/150?img=3',
    },
  ],
}
